// export function productEditFlag({ status, repeatType }: { status: string, repeatType: string }): boolean {
export function productEditFlag({ status }: { status: string }): boolean {
  if([ 'Closed', 'Open' ].includes(status)) return false;
  // if(repeatType == 'Repeat') return false;
  return true;
}